// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Button } from '@iheartjane/reefer';
import { shadows } from '@iheartjane/reefer-emotion';

export const StyledButtonIcon = styled(Button.Icon)({
  boxShadow: shadows.hard,
  height: '32px',
  width: '32px',
  minWidth: '32px',
  padding: 0,
});
